import React from 'react';

type OwnProps = {
  className?: string;
};

const FinancingTerms = ({ className }: OwnProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    className={className}
  >
    <g>
      <g>
        <path d="M3.318 4.451h2v4.018h-2zm4.001 0h2v4.018h-2zM6.319 0L0 2.417v2.034h1.319v4.017h-.162v1.024H0v2h12.637v-2h-1.156V8.468h-.162V4.451h1.318V2.417z" />
      </g>
    </g>
  </svg>
);

export default FinancingTerms;
